if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return attribute.trim();
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {    
  fetch('/cart/update.js?note=' + attributeToString(note), {
    method: 'POST'    
  }).then(function (cart) {
    if ((typeof callback) === 'function') {
      callback(cart);      
    }
    else {
      ShopifyAPI.onCartUpdate(cart);      
    }
    document.body.dispatchEvent(new CustomEvent('afterUpdateCartNote.ajaxCart', { note: note, cart: cart }));
  }).catch(function (XMLHttpRequest, textStatus) {
    document.body.dispatchEvent(new CustomEvent('errorUpdateCartNote.ajaxCart', { XMLHttpRequest: XMLHttpRequest, textStatus: textStatus }));    
    ShopifyAPI.onError(XMLHttpRequest, textStatus);
  });
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    //alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {    
  document.body.dispatchEvent(new CustomEvent('beforeAddItem.ajaxCart', { form: form }));
  
  fetch('/cart/add.js', {
    method: 'POST',
    body: new FormData(form)
  }).then(function (line_item) {
    if ((typeof callback) === 'function') {
      callback(line_item, form);      
    }
    else {
      ShopifyAPI.onItemAdded(line_item, form);      
    }

    document.body.dispatchEvent(new CustomEvent('afterAddItem.ajaxCart', { line_item: line_item, form: form }));
  }).catch(function (XMLHttpRequest, textStatus) {
    if ((typeof errorCallback) === 'function') {
      errorCallback(XMLHttpRequest, textStatus);
    }
    else {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
    document.body.dispatchEvent(new CustomEvent('errorAddItem.ajaxCart', { XMLHttpRequest: XMLHttpRequest, textStatus: textStatus }));    
  });
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {  
  document.body.dispatchEvent(new CustomEvent('beforeGetCart.ajaxCart'));

  fetch('/cart.js').then(data => data.text()).then(data => {
    var cart = JSON.parse(data);

    if ((typeof callback) === 'function') {
      callback(cart);      
    } else {
      ShopifyAPI.onCartUpdate(cart);      
    }

    document.body.dispatchEvent(new CustomEvent('afterGetCart.ajaxCart', { cart: cart }));
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  document.body.dispatchEvent(new CustomEvent('beforeChangeItem.ajaxCart'));

  fetch('/cart/change.js?quantity=' + quantity + '&line=' + line, {
    method: 'POST',    
    headers: { 'Content-Type': 'application/json', 'Accept': `application/json` }
  }).then(data => data.text()).then(function (dataText) {        
    var cart = JSON.parse(dataText);

    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }

    document.body.dispatchEvent(new CustomEvent('afterChangeItem.ajaxCart', { line: line, quantity: quantity, cart: cart }));        
  }).catch(function (XMLHttpRequest, textStatus) {    
    document.body.dispatchEvent(new CustomEvent('errorChangeItem.ajaxCart', { XMLHttpRequest: XMLHttpRequest, textStatus: textStatus }));    
    ShopifyAPI.onError(XMLHttpRequest, textStatus);
  });
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
function ajaxCartFunc(module) {

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#cartSidebarContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$\{\{amount\}\}',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    Object.assign(settings, options);
    
    // Select DOM elements
    $formContainer     = document.querySelectorAll(settings.formSelector);
    $cartContainer     = document.querySelector(settings.cartContainer);
    $addToCart         = document.querySelectorAll(settings.addToCartSelector);
    $cartCountSelector = document.querySelector(settings.cartCountSelector);
    $cartCostSelector  = document.querySelector(settings.cartCostSelector);
    
    // Track cart activity status
    isUpdating = false;

    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }    

   adjustCart();
  };

  loadCart = function () {
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.innerHTML = cart.item_count;
      $cartCountSelector.closest(".header__cart-count").classList.remove('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.closest(".header__cart-count").classList.add('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.innerHTML = Shopify.formatMoney(cart.total_price, settings.moneyFormat);
    }
  };

  formOverride = function () {
    $formContainer.forEach(formItem => {
      formItem.addEventListener('submit', function (evt) {        
        evt.preventDefault();

        // Add class to be styled if desired
        formItem.querySelector(settings.addToCartSelector).classList.remove('is-added');
        formItem.querySelector(settings.addToCartSelector).classList.add('is-adding');
  
        // Remove any previous quantity errors
        document.querySelectorAll('.qty-error').forEach(err => {
          err.parentNode.removeChild(err);
        });

        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
      });
    });
  };

  itemAddedCallback = function (product) {    
    $addToCart.forEach(item => {
      if (item.classList.contains('is-adding')) {
        item.classList.replace('is-adding', 'is-added');        
      }
    });

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');    

    $addToCart.forEach(item => {      
        item.classList.remove('is-adding', 'is-added');        
    });

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.forEach(formItem => {
          formItem.after('<div class="errors qty-error">' + data.description + '</div>')
        });
      }
    }
  };

  cartUpdateCallback = function (cart) {    
    updateCountPrice(cart);
    buildCart(cart);    
  };

  buildCart = function (cart) {
    $cartContainer.innerHTML = '';
    
    if (cart.item_count === 0) {
      var cartEmptyLabel = "Seu carrinho está vazio no momento.";                
      $cartContainer.innerHTML = $cartContainer.innerHTML + '<p class="row columns">' + cartEmptyLabel + '</p>';
      cartCallback(cart);
      return;
    }
    
    var items = [],
        item = {},
        data = {};

      
    cart.items.forEach((cartItem, index) => {                  
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,  
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };      

      items.push(item);
    });
    

    // Gather all cart data and add to DOM
    var savingsText = `Você está economizando [savings]`;

    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : savingsText.replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),      
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.innerHTML = JSCart(data);

    adjustCart();

    cartCallback(cart);
  };

  cartCallback = function (cart) {    
    document.body.dispatchEvent(new CustomEvent('afterCartLoad.ajaxCart', { detail: cart }));

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {    
    document.querySelectorAll('#cartSidebarContainer .js-qty__num').forEach(amountInput => {      
      amountInput.addEventListener('change', function (evt) {        
        if (isUpdating)
          return;
      
        var el = evt.target,
        line = el.getAttribute('data-line'),
        qty = parseInt(el.value.replace(/\D/g, ''));
        var qty = validateQty(qty);          

        if (line) {
          updateQuantity(line, qty);
        }
      });            
    });

    document.querySelectorAll('form.ajaxcart').forEach(formItem => {
      formItem.addEventListener('submit', function (evt) {
        if (isUpdating) {
          evt.preventDefault();
        }
      });
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities      
      var row = document.querySelector('.ajaxcart__row[data-line="' + line + '"]');
      row.classList.add('is-loading');

      if (qty === 0) {        
        row.parentNode.classList.add('is-removed');
      }
      
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    var note = document.querySelector('textarea[name="note"]');
    if (note) {
      note.addEventListener('change', function (evt) {
        var newNote = evt.target.value;
        ShopifyAPI.updateCartNote(newNote, function(cart) {});
      });
    }
  };

  adjustCartCallback = function (cart) {
    updateCountPrice(cart);
    
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  validateQty = function (qty) {
    if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {      
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;
}

var ajaxCart = ajaxCartFunc();

function CartInit() {  
  ajaxCart.init({
    formSelector: 'form[action^="/cart/add"]',
    cartContainer: '#cartSidebarContainer',
    addToCartSelector: '.addToCartButton',
    cartCountSelector: '#CartCount',
    cartCostSelector: '#CartCost',    
    moneyFormat: universe.shopMoneyFormat
  });
}

CartInit();

document.body.addEventListener('afterCartLoad.ajaxCart', function(evt, cart) {
  var event = new CustomEvent("activateSidebar", { detail: { sidebarId: "cartSidebar" } });
  document.dispatchEvent(event);
});

document.body.addEventListener('relatedProductsLoaded', function(evt) {
  CartInit();
});

if (universe.ajaxCartMethod == "drawer") {
  document.addEventListener('sidebarOpen', function (e) {    
    if (e.detail.sidebarId == "cartSidebar") {
      ajaxCart.load();
    }
  });
}